var NavBarBgColor;
(function (NavBarBgColor) {
    /** Color used by default for unauthenticated experience */
    NavBarBgColor["LIGHT_GREY"] = "light-grey";
    /** Color used by default when authenticated */
    NavBarBgColor["WHITE"] = "white";
})(NavBarBgColor || (NavBarBgColor = {}));

export { NavBarBgColor };
